// API that generates fake users
const api_url = 'https://jsonplaceholder.typicode.com/users';

export default api_url;